// import React, { lazy, Suspense, useEffect } from 'react';
// import {
//   Route,
//   Routes,
//   Navigate,
//   useLocation,
//   useNavigate,
// } from 'react-router-dom';
// import { useSelector } from 'react-redux';
// import Loader from '../components/loader/Loader.jsx';
// import ErrorBoundary from '../ErrorBoundary.jsx';
// import Error404 from '../Pages/404.js';

// // Lazy load components
// const Login = lazy(() => import('../Pages/Login.jsx'));
// const Register = lazy(() => import('../Pages/Register.jsx'));
// const RegisterDashboard = lazy(() => import('../Pages/RegisterDashboard.jsx'));
// const ExpertEngagementsDashboard = lazy(() => import('../Pages/ExpertDashboard.jsx'));
// const OrderFileExplorer = lazy(() => import('../Pages/OrderFileExplorer.jsx'));

// // Auth Guard Component
// const AuthGuard = ({ children }) => {
//   const location = useLocation();
//   const auth = useSelector((state) => state.auth);
//   const register = useSelector((state) => state.register);
  
//   // Check both auth systems
//   const isLoggedIn = auth.isLoggedIn || register.isLoggedIn;
//   const profileStatus = register.profileStatus || auth.profileStatus;
  
//   if (!isLoggedIn) {
//     const currentPath = location.pathname;
//     if (currentPath !== '/tutor_dashboard/login' && currentPath !== '/tutor_dashboard/register') {
//       sessionStorage.setItem('redirectAfterLogin', currentPath);
//     }
    
//     return (
//       <Navigate 
//         to="/tutor_dashboard/login" 
//         replace 
//         state={{ from: location }} 
//       />
//     );
//   }

//   // Check if user needs to complete profile
//   if (profileStatus === 'email_verified' && location.pathname !== '/tutor_dashboard/register-dashboard') {
//     return (
//       <Navigate 
//         to="/tutor_dashboard/register-dashboard" 
//         replace 
//       />
//     );
//   }

//   return children;
// };

// // Protected Route Wrapper
// const ProtectedRoute = ({ children }) => {
//   return (
//     <AuthGuard>
//       <ErrorBoundary>
//         <Suspense fallback={<Loader />}>
//           {children}
//         </Suspense>
//       </ErrorBoundary>
//     </AuthGuard>
//   );
// };

// // Public Route Wrapper
// const PublicRoute = ({ children }) => {
//   return (
//     <ErrorBoundary>
//       <Suspense fallback={<Loader />}>
//         {children}
//       </Suspense>
//     </ErrorBoundary>
//   );
// };

// const Routey = () => {
//   const auth = useSelector((state) => state.auth);
//   const register = useSelector((state) => state.register);
//   const location = useLocation();
//   const navigate = useNavigate();

//   // Check both auth systems
//   const isLoggedIn = auth.isLoggedIn || register.isLoggedIn;
//   const profileStatus = register.profileStatus || auth.profileStatus;

//   // Handle post-login redirect
//   useEffect(() => {
//     if (isLoggedIn && (location.pathname === '/tutor_dashboard/login' || location.pathname === '/tutor_dashboard/register')) {
//       const redirectTo = sessionStorage.getItem('redirectAfterLogin');
      
//       if (redirectTo && redirectTo.startsWith('/tutor_dashboard')) {
//         sessionStorage.removeItem('redirectAfterLogin');
//         navigate(redirectTo, { replace: true });
//       } else {
//         if (profileStatus === 'email_verified') {
//           navigate('/tutor_dashboard/register-dashboard', { replace: true });
//         } else {
//           navigate('/tutor_dashboard', { replace: true });
//         }
//       }
//     }
//   }, [isLoggedIn, location.pathname, navigate, profileStatus]);

//   return (
//     <ErrorBoundary>
//       <Routes>
//         {/* Default dashboard route */}
//         <Route
//           path="/"
//           element={
//             <ProtectedRoute>
//               <ExpertEngagementsDashboard />
//             </ProtectedRoute>
//           }
//         />

//         {/* Login route */}
//         <Route
//           path="/login"
//           element={
//             isLoggedIn ? (
//               <Navigate to="/tutor_dashboard" replace />
//             ) : (
//               <PublicRoute>
//                 <Login />
//               </PublicRoute>
//             )
//           }
//         />

//         {/* Register route */}
//         <Route
//           path="/register"
//           element={
//             isLoggedIn ? (
//               <Navigate to="/tutor_dashboard" replace />
//             ) : (
//               <PublicRoute>
//                 <Register />
//               </PublicRoute>
//             )
//           }
//         />

//         {/* Register form route */}
//         <Route
//           path="/register-dashboard"
//           element={
//             <ProtectedRoute>
//               <RegisterDashboard />
//             </ProtectedRoute>
//           }
//         />

//         {/* File explorer route */}
//         <Route
//           path="/file-explorer/:orderId"
//           element={
//             <ProtectedRoute>
//               <OrderFileExplorer />
//             </ProtectedRoute>
//           }
//         />

//         {/* 404 route */}
//         <Route 
//           path="*" 
//           element={
//             <ErrorBoundary>
//               <Suspense fallback={<Loader />}>
//                 <Error404 />
//               </Suspense>
//             </ErrorBoundary>
//           } 
//         />
//       </Routes>
//     </ErrorBoundary>
//   );
// };

// export default Routey;


import React, { lazy, Suspense, useEffect } from 'react';
import {
  Route,
  Routes,
  Navigate,
  useLocation,
  useNavigate,
} from 'react-router-dom';
import { useSelector } from 'react-redux';
import Loader from '../components/loader/Loader.jsx';
import ErrorBoundary from '../ErrorBoundary.jsx';
import Error404 from '../Pages/404.js';

// Lazy load components for login system only
const Login = lazy(() => import('../Pages/Login.jsx'));
const ExpertEngagementsDashboard = lazy(() => import('../Pages/ExpertDashboard.jsx'));
const OrderFileExplorer = lazy(() => import('../Pages/OrderFileExplorer.jsx'));

// Auth Guard Component - Only for login system
const AuthGuard = ({ children }) => {
  const location = useLocation();
  const auth = useSelector((state) => state.auth);
  
  console.debug('[AuthGuard] isLoggedIn:', auth.isLoggedIn);
  console.debug('[AuthGuard] current location:', location.pathname);

  if (!auth.isLoggedIn) {
    // Save redirect path for after login
    if (location.pathname !== '/tutor_dashboard/login') {
      sessionStorage.setItem('redirectAfterLogin', location.pathname);
    }
    return <Navigate to="/tutor_dashboard/login" replace state={{ from: location }} />;
  }

  return children;
};

// Protected Route Wrapper - Only for login system
const ProtectedRoute = ({ children }) => {
  return (
    <AuthGuard>
      <ErrorBoundary>
        <Suspense fallback={<Loader />}>
          {children}
        </Suspense>
      </ErrorBoundary>
    </AuthGuard>
  );
};

const LoginRoutes = () => {
  const auth = useSelector((state) => state.auth);
  const location = useLocation();
  const navigate = useNavigate();

  // Handle post-login redirect - Only for auth system
  useEffect(() => {
    if (auth.isLoggedIn && location.pathname === '/tutor_dashboard/login') {
      const redirectTo = sessionStorage.getItem('redirectAfterLogin');
      if (redirectTo && redirectTo.startsWith('/tutor_dashboard')) {
        sessionStorage.removeItem('redirectAfterLogin');
        navigate(redirectTo, { replace: true });
      } else {
        navigate('/tutor_dashboard', { replace: true });
      }
    }
  }, [auth.isLoggedIn, location.pathname, navigate]);

  return (
    <ErrorBoundary>
      <Routes>
        {/* Default tutor dashboard route */}
        <Route
          path="/"
          element={
            <ProtectedRoute>
              <ExpertEngagementsDashboard />
            </ProtectedRoute>
          }
        />

        {/* Login route for tutor dashboard */}
        <Route
          path="/login"
          element={
            auth.isLoggedIn ? (
              <Navigate to="/tutor_dashboard" replace />
            ) : (
              <ErrorBoundary>
                <Suspense fallback={<Loader />}>
                  <Login />
                </Suspense>
              </ErrorBoundary>
            )
          }
        />

        {/* File explorer route with orderId param */}
        <Route
          path="/file-explorer/:orderId"
          element={
            <ProtectedRoute>
              <OrderFileExplorer />
            </ProtectedRoute>
          }
        />

        {/* Additional tutor dashboard routes can be added here */}
        
        {/* Catch all 404 for tutor dashboard */}
        <Route 
          path="*" 
          element={
            <ErrorBoundary>
              <Suspense fallback={<Loader />}>
                <Error404 />
              </Suspense>
            </ErrorBoundary>
          } 
        />
      </Routes>
    </ErrorBoundary>
  );
};

export default LoginRoutes;
